/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEmailDeliveryStatus } from './ControlEmailDeliveryStatus';
import {
    ControlEmailDeliveryStatusFromJSON,
    ControlEmailDeliveryStatusFromJSONTyped,
    ControlEmailDeliveryStatusToJSON,
} from './ControlEmailDeliveryStatus';
import type { ControlZeroDayAlertClientNotificationEvent } from './ControlZeroDayAlertClientNotificationEvent';
import {
    ControlZeroDayAlertClientNotificationEventFromJSON,
    ControlZeroDayAlertClientNotificationEventFromJSONTyped,
    ControlZeroDayAlertClientNotificationEventToJSON,
} from './ControlZeroDayAlertClientNotificationEvent';
import type { ControlZeroDayAlertEscalationStatus } from './ControlZeroDayAlertEscalationStatus';
import {
    ControlZeroDayAlertEscalationStatusFromJSON,
    ControlZeroDayAlertEscalationStatusFromJSONTyped,
    ControlZeroDayAlertEscalationStatusToJSON,
} from './ControlZeroDayAlertEscalationStatus';
import type { ControlZeroDayAlertResolutionStatus } from './ControlZeroDayAlertResolutionStatus';
import {
    ControlZeroDayAlertResolutionStatusFromJSON,
    ControlZeroDayAlertResolutionStatusFromJSONTyped,
    ControlZeroDayAlertResolutionStatusToJSON,
} from './ControlZeroDayAlertResolutionStatus';

/**
 * 
 * @export
 * @interface ControlZeroDayAlertClientSearchResult
 */
export interface ControlZeroDayAlertClientSearchResult {
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    zero_day_alert_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    client_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    org_id?: string;
    /**
     * 
     * @type {ControlZeroDayAlertResolutionStatus}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    resolution_status?: ControlZeroDayAlertResolutionStatus;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    resolved_by?: string;
    /**
     * 
     * @type {number}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    resolved_version?: number;
    /**
     * 
     * @type {ControlZeroDayAlertEscalationStatus}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    escalation_status?: ControlZeroDayAlertEscalationStatus;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    assignee?: string;
    /**
     * 
     * @type {ControlZeroDayAlertClientNotificationEvent}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    last_notification_event?: ControlZeroDayAlertClientNotificationEvent;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    impacted_assets?: { [key: string]: Array<string>; };
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    resolved_assets?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    exposure_usd?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    company_name: string;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    entity_id: string;
    /**
     * 
     * @type {ControlEmailDeliveryStatus}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    email_delivery_status?: ControlEmailDeliveryStatus;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    primary_security_contact?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    policy_number?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    policyholder_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    policyholder_email?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    policyholder_phone?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    zoominfo_phone?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    broker_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    broker_email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    is_msp?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    is_msad?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlZeroDayAlertClientSearchResult
     */
    is_mdr_customer?: boolean;
}

/**
 * Check if a given object implements the ControlZeroDayAlertClientSearchResult interface.
 */
export function instanceOfControlZeroDayAlertClientSearchResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "zero_day_alert_id" in value;
    isInstance = isInstance && "client_id" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "company_name" in value;
    isInstance = isInstance && "entity_id" in value;

    return isInstance;
}

export function ControlZeroDayAlertClientSearchResultFromJSON(json: any): ControlZeroDayAlertClientSearchResult {
    return ControlZeroDayAlertClientSearchResultFromJSONTyped(json, false);
}

export function ControlZeroDayAlertClientSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlZeroDayAlertClientSearchResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'zero_day_alert_id': json['zero_day_alert_id'],
        'client_id': json['client_id'],
        'org_id': !exists(json, 'org_id') ? undefined : json['org_id'],
        'resolution_status': !exists(json, 'resolution_status') ? undefined : ControlZeroDayAlertResolutionStatusFromJSON(json['resolution_status']),
        'resolved_by': !exists(json, 'resolved_by') ? undefined : json['resolved_by'],
        'resolved_version': !exists(json, 'resolved_version') ? undefined : json['resolved_version'],
        'escalation_status': !exists(json, 'escalation_status') ? undefined : ControlZeroDayAlertEscalationStatusFromJSON(json['escalation_status']),
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'assignee': !exists(json, 'assignee') ? undefined : json['assignee'],
        'last_notification_event': !exists(json, 'last_notification_event') ? undefined : ControlZeroDayAlertClientNotificationEventFromJSON(json['last_notification_event']),
        'impacted_assets': !exists(json, 'impacted_assets') ? undefined : json['impacted_assets'],
        'resolved_assets': !exists(json, 'resolved_assets') ? undefined : json['resolved_assets'],
        'exposure_usd': !exists(json, 'exposure_usd') ? undefined : json['exposure_usd'],
        'created': json['created'],
        'company_name': json['company_name'],
        'entity_id': json['entity_id'],
        'email_delivery_status': !exists(json, 'email_delivery_status') ? undefined : ControlEmailDeliveryStatusFromJSON(json['email_delivery_status']),
        'primary_security_contact': !exists(json, 'primary_security_contact') ? undefined : json['primary_security_contact'],
        'policy_number': !exists(json, 'policy_number') ? undefined : json['policy_number'],
        'policyholder_name': !exists(json, 'policyholder_name') ? undefined : json['policyholder_name'],
        'policyholder_email': !exists(json, 'policyholder_email') ? undefined : json['policyholder_email'],
        'policyholder_phone': !exists(json, 'policyholder_phone') ? undefined : json['policyholder_phone'],
        'zoominfo_phone': !exists(json, 'zoominfo_phone') ? undefined : json['zoominfo_phone'],
        'broker_name': !exists(json, 'broker_name') ? undefined : json['broker_name'],
        'broker_email': !exists(json, 'broker_email') ? undefined : json['broker_email'],
        'is_msp': !exists(json, 'is_msp') ? undefined : json['is_msp'],
        'is_msad': !exists(json, 'is_msad') ? undefined : json['is_msad'],
        'is_mdr_customer': !exists(json, 'is_mdr_customer') ? undefined : json['is_mdr_customer'],
    };
}

export function ControlZeroDayAlertClientSearchResultToJSON(value?: ControlZeroDayAlertClientSearchResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'zero_day_alert_id': value.zero_day_alert_id,
        'client_id': value.client_id,
        'org_id': value.org_id,
        'resolution_status': ControlZeroDayAlertResolutionStatusToJSON(value.resolution_status),
        'resolved_by': value.resolved_by,
        'resolved_version': value.resolved_version,
        'escalation_status': ControlZeroDayAlertEscalationStatusToJSON(value.escalation_status),
        'notes': value.notes,
        'assignee': value.assignee,
        'last_notification_event': ControlZeroDayAlertClientNotificationEventToJSON(value.last_notification_event),
        'impacted_assets': value.impacted_assets,
        'resolved_assets': value.resolved_assets,
        'exposure_usd': value.exposure_usd,
        'created': value.created,
        'company_name': value.company_name,
        'entity_id': value.entity_id,
        'email_delivery_status': ControlEmailDeliveryStatusToJSON(value.email_delivery_status),
        'primary_security_contact': value.primary_security_contact,
        'policy_number': value.policy_number,
        'policyholder_name': value.policyholder_name,
        'policyholder_email': value.policyholder_email,
        'policyholder_phone': value.policyholder_phone,
        'zoominfo_phone': value.zoominfo_phone,
        'broker_name': value.broker_name,
        'broker_email': value.broker_email,
        'is_msp': value.is_msp,
        'is_msad': value.is_msad,
        'is_mdr_customer': value.is_mdr_customer,
    };
}

